// removed by extract-text-webpack-plugin
module.exports = {"cannedReplyEmpty":"cannedReplyEmpty__3TQXKd8MisoO"};